/**
 * @ngdoc object
 * @name bo.objects.controller:BoObjectDetailsController
 *
 * @description
 *
 */

class BoObjectDetailsController {

    constructor($http, $state, $stateParams, Alert, NavService, BoOptions, NavHelper) {
        this.api = $http;
        this.state = $state;
        this.stateParams = $stateParams;
        this.alert = Alert;
        this.navService = NavService;
        this.navHelper = NavHelper;
        this.originalOptionsStore = BoOptions;
        this.optionsStore = null;
        this.model = null;
        this.objectModel = null;
        this.currentView = 'meta';

        this._loadObject()
    }

    _loadObject() {
        this.api.get(`bo/objects/${this.stateParams.objectId}`).then((response) => {
            this.model = response.data.data;
            this.objectModel = this.model;
            this._updateNavigation();
        }, () => {
            this.alert.error('Error', 'Error while loading bookable object');
            this.state.back();
        });
    }

    _updateNavigation() {
        if (!this.model) {
            return;
        }

        this.navHelper.setTranslationsParamsForEntry('settings.custom_defaults.bo-objects.details.main', {
            name: this.model.label
        });

        this.navService.overrideMainSideNavActions([
            {
                key: 'edit-object',
                title: 'Edit',
                icon: 'pencil',
                action: () => {
                    this.editModel();
                }
            }
        ]);
    }

    openOptionDetails(action, store) {
        this.state.go('app.bo.options.details', {
            objectId: this.model.id,
            id: action.row.id
        });
    }

    addNewOption() {
        this.state.go('app.bo.options.create', {
            objectId: this.model.id
        });
    }

    editModel() {
        this.state.go('app.bo.objects.edit', {id: this.model.id});
    }
}

BoObjectDetailsController.$inject = [
    '$http',
    '$state',
    '$stateParams',
    'Alert',
    'NavService',
    'BoOptions',
    'NavHelper'
];

angular
    .module('festzelt-os.modules.bo.objects')
    .controller('BoObjectDetailsController', BoObjectDetailsController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/objects/controllers/details-controller.js